module.exports = __webpack_public_path__ + "static/media/8-9.78b8a0b4.mp3";